import Report from './Report';

export default Report
export { Report as Base }
